var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import EdsTextLink from '@ellucian/react-design-system/core/es/TextLink';
import Icon from '../Icon';
import Text from '../Text';
const TextLink = (props, ref) => {
    const { IconProps, TextProps, children, component, onClick } = props, rest = __rest(props, ["IconProps", "TextProps", "children", "component", "onClick"]);
    function onKeydown(event) {
        if ((event.key === 'Enter' || event.key === ' ') && onClick !== undefined) {
            event.preventDefault();
            onClick(event);
        }
    }
    const content = (React.createElement(React.Fragment, null,
        IconProps && (React.createElement(Icon, Object.assign({ marginRight: true }, IconProps))),
        children));
    const BaseTextLink = (React.createElement(EdsTextLink, Object.assign({ component: onClick ? 'span' : component || 'a', role: onClick ? 'button' : null, tabIndex: "0", onClick: onClick, onKeyDown: onKeydown, ref: ref }, rest), content));
    if (TextProps) {
        return (React.createElement(Text, Object.assign({ component: "span" }, TextProps), BaseTextLink));
    }
    else {
        return (React.createElement(React.Fragment, null, BaseTextLink));
    }
};
const TextLinkFRC = forwardRef(TextLink);
TextLinkFRC.displayName = 'TextLinkFRC';
export default TextLinkFRC;
